import { Button, styled } from '@mui/material';
import { Dropdown, MenuPopover } from '@fluentui/react-components';

const MENU_MAX_WIDTH = 230;
const MENU_ITEM_MAX_WIDTH = MENU_MAX_WIDTH - 30;

export const SettingsPopover = styled(MenuPopover)`
  max-width: ${MENU_MAX_WIDTH}px;
  padding-right: 10px;
  padding-left: 10px;
`;

export const ManageConsentButton = styled(Button)`
  margin: 12px auto;
  padding: 4px 8px;
  text-transform: initial;
  background-color: ${({ theme }) => theme.palette.consentButtonColor.background};
  color: ${({ theme }) => theme.palette.consentButtonColor.main};
  width: 90%;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const SettingItemDropdownWrapper = styled(Dropdown)`
  min-width: ${MENU_ITEM_MAX_WIDTH}px;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
  display: block;
`;
